import { Language } from 'core/models/common';
import i18n from 'i18n';

export const onChangeLanguage: () => void = () => {
	if (i18n.language === 'ar') {
		i18n.changeLanguage('en');
		localStorage.setItem('language', 'en');
		document.body.dir = 'ltr';
	} else {
		i18n.changeLanguage('ar');
		localStorage.setItem('language', 'ar');
		document.body.dir = 'rtl';
	}
};

export const getDefaultLanguage = (): Language => {
	return (localStorage.getItem('language') || 'en') as Language;
};

export const isRTL = () => {
	return i18n.dir() === 'rtl';
};
